import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'pioneer-payment-layout',
  templateUrl: './payment-layout.component.html',
})
export class PaymentLayoutComponent implements OnInit, OnDestroy {

  showLayout = false;

  year: number = new Date().getFullYear();

  constructor(
    private layoutService: LayoutService,
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.layoutService.showLayout.next(this.showLayout);
    });
  }

  ngOnDestroy(): void {
    this.layoutService.resetShowLayout();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/payment-layout/payment-layout.component.ts